import React from 'react';
import Dropdown from 'ub/components/dropdown/dropdown';
import {paragraphStyles} from './text-panel-defaults';

export default function ParagraphStyle({changeHandler, selectedValue}) {
  const _changeParagraphStyle = (style) => {
    changeHandler({
      type: 'paragraphStyleChange',
      value: style
    });
  };

  const optionMap = paragraphStyles
    .filter(style => style.isSelectable)
    .map(style => ({
      className: 'option-' + style.value,
      value: style.value,
      label: style.label
    }));

  const selectedParagraphStyle = paragraphStyles.find(style => style.value === selectedValue);

  return (
    <Dropdown
      className="paragraph-style-dropdown"
      changeHandler={_changeParagraphStyle}
      options={optionMap}
      value={selectedParagraphStyle ? selectedParagraphStyle.value : null}
      label={selectedParagraphStyle ? selectedParagraphStyle.label : "No paragraph style"}
    />
  );
}

ParagraphStyle.propTypes = {
  selectedValue: React.PropTypes.string,
  changeHandler: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content-components/paragraph-style.jsx